<ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{
  tagTypes: (filteredTagTypes$ | async) ?? [],
  selectedTagTypes: (selectedTagTypes$ | async) ?? [],
  editingTagType: (editingTagType$ | async) ?? null
}"> </ng-container>


<ng-template #template let-tagTypes="tagTypes" let-selectedTagTypes="selectedTagTypes"
  let-editingTagType="editingTagType">
  <div class="menu-section">
    <div flexLayout="column" flexLayoutAlign="start stretch">
      <div *ngFor="let tagType of selectedTagTypes; trackBy: trackTagTypeById"
        [class.editing]="editingTagType?.tagTypeId === tagType.tagTypeId" class="menu-item selected" flexLayout="row"
        flexLayoutAlign="space-between center">
        <div>{{tagType.displayName}}</div>
        <mat-icon (click)="removeSelected(tagType)">close</mat-icon>
      </div>
      <div *ngFor="let tagType of tagTypes; trackBy: trackTagTypeById" class="menu-item" flexLayout="row"
        flexLayoutAlign="start center" (click)="tagTypeSelected(tagType)">
        <div>{{tagType.displayName}}</div>
      </div>
    </div>
  </div>
</ng-template>
